import qs from "qs";

import authFormFieldsToRequestData from "../authFormFieldsToRequestData";
import firstParam from "../firstParam";
import {
  OTP_FROM_REGISTER_QUERY_PARAM,
  OTP_HASH_QUERY_PARAM
} from "./authOtpConstants";

function parseTruthyFlag(value) {
  return value === "true" || value === true;
}

export function parseLoginOtpFragmentParams(hashFragment = "") {
  if (!hashFragment) {
    return { hash: null, fromRegister: false };
  }

  const normalized = hashFragment.startsWith("#")
    ? hashFragment.slice(1)
    : hashFragment;

  if (!normalized) {
    return { hash: null, fromRegister: false };
  }

  const params = qs.parse(normalized);
  const hash = firstParam(params[OTP_HASH_QUERY_PARAM]) || null;

  return {
    hash,
    fromRegister: parseTruthyFlag(
      firstParam(params[OTP_FROM_REGISTER_QUERY_PARAM])
    )
  };
}

export function parseLoginOtpHashFromFragment(hashFragment = "") {
  return parseLoginOtpFragmentParams(hashFragment).hash;
}

export function getLoginOtpNavigationState({ user, fromRegister = false }) {
  return {
    user,
    fromRegister
  };
}

export function getRegisterOtpNavigationState(fields) {
  const { email } = authFormFieldsToRequestData(fields);

  return getLoginOtpNavigationState({
    user: email,
    fromRegister: true
  });
}

export function hasLoginOtpNavigationState(state) {
  return Boolean(state?.user);
}

/** Expo-router-friendly scalar params for navigateToScene("loginOtp", …). */
export function getLoginOtpRouteParams({ user, fromRegister = false }) {
  return {
    user,
    fromRegister: fromRegister ? "true" : "false"
  };
}

export function parseLoginOtpRouteParams(routeParams = {}) {
  const user = routeParams.user;
  const fromRegister = parseTruthyFlag(firstParam(routeParams.fromRegister));
  const hash = firstParam(
    routeParams[OTP_HASH_QUERY_PARAM] ?? routeParams.hash
  );

  return { user, fromRegister, hash };
}

export function hasLoginOtpRouteParams(routeParams) {
  if (!routeParams) {
    return false;
  }

  return Boolean(
    routeParams.user ||
      firstParam(routeParams[OTP_HASH_QUERY_PARAM] ?? routeParams.hash)
  );
}

export function isLoginOtpHashMode(routeParams = {}) {
  return Boolean(
    firstParam(routeParams[OTP_HASH_QUERY_PARAM] ?? routeParams.hash)
  );
}
